export default {
  errors: {
    uid_already_exists:
      'En bruker med din ID eksisterer allerede; vennligst ta kontakt.',
    invalid_action_code:
      'Denne linken er ugyldig. Dette kan skje om den ikke er hel, uløpt eller brukt allerede.',
    account_exists_with_different_credential:
      'E-posten du skrev inn eksisterer allerede. Kanskje du allerede har opprettet bruker med en annen innloggingsmetode?',
    declined_terms: 'Godta våre personvernvilkår for å bruke Ducky.',
    email_already_in_use:
      'Denne e-posten er allerede registrert. Logg inn eller bruk en annen e-postadresse.',
    no_code:
      'Kunne ikke logge deg inn. Vennligst send oss informasjonen under og vi vil hjelpe deg så fort vi kan.',
    popup_blocked:
      'Din nettleser ser ut til å blokkere pop-up vinduet for innlogging.',
    popup_closed_by_user:
      'Pop-up-vinduet for innlogging er lukket før vi kunne logge deg på.',
    too_many_requests:
      'Du forsøkte å logge inn for fort etter en feilet innlogging, vent noen sekunder og prøv igjen.',
    facebook_creation_failed:
      'Registrering med din Facebook-bruker feilet. Kanskje du har registrert deg med e-post og passord eller med Google hvor e-posten er den samme som det din Facebook-bruker har?',
    facebook_has_no_email:
      'Din Facebook-bruker har ikke en registrert e-post addresse. Vennligst login med Google eller opprett en bruker med e-post og passord.',
    google_login_failed:
      'Registrering med din Google-bruker feilet. Kanskje du har registrert deg med e-post eller med Feide hvor e-posten er den samme som det din Google-bruker har?',
    rate_limit:
      'For mange forespørsler. Vennligst vent en stund og prøv igjen.',
    invalid_login: 'Ugyldig e-postadresse eller passord. Vennligst prøv igjen.',
  },
  fieldErrors: {
    invalid_email: 'Ugyldig e-postadresse',
    only_letters: 'Kan bare inneholde bokstaver',
    too_short: 'Må inneholde %{length} eller flere bokstaver',
    mandatory: 'Må fylles ut',
    password_mismatch: 'Passordene stemmer ikke overens',
    email_no_quotes: `Dy kan ikke ha en ' in en e-postadresse`,
    email_valid_TLD: '.%{tld} er ikke en gyldig e-postadresse',
  },
  create_sustainable_society: 'Sammen kan vi skape et bærekraftig samfunn',
  verify_email:
    'Vennligst gjenta ditt navn og epost for å verifisere at det virkelig er deg.',
  or_with_email: 'Eller med e-post',
  close: 'Lukk',
  confirm_account: 'Bekreft konto',
  back_to_login: 'Tilbake til logg inn',
  back_to_registration: 'Tilbake til registrering',
  error: 'Feil:\r\n%{errorMessage}',
  existing_user: 'Har du allerede konto?',
  forgot_password: 'Glemt passord',
  forgot_password_confirmation_description:
    'En e-post med instruksjoner er sendt til din e-postadresse.',
  send_forgot_password_email:
    'Null stress! Skriv inn e-postadressen din, så sender vi deg en lenke du kan bruke til å endre passordet ditt.',
  send_create_password_email:
    'Null stress! Skriv inn e-postadressen din, så sender vi deg en lenke du kan bruke til å skape passordet ditt.',
  go_back_to: 'Gå tilbake til',
  login_with_facebook: 'Logg inn med Facebook',
  login_with_google: 'Logg inn med Google',
  lost_password: 'Glemt passord?',
  need_password: 'Trenger du passord?',
  min_password_length: 'Passordet må ha mer enn seks tegn',
  missing_password: 'Skriv inn passord',
  must_log_in:
    'Du må logge deg inn som bruker på Ducky for å utføre denne handlingen.',
  new_user: 'Ny bruker?',
  not_logged_in: 'Du er ikke logget inn',
  or_login_with_email: 'Eller logg inn med epost',
  or_register_with_email: 'Eller registrer med navn og e-post',
  password_reset_sent:
    'Vi har sendt deg en e-post med instruksjoner for å endre passord',
  provider_login_error: 'Feil med %{provider}-innlogging',
  provider_error_description:
    'Du prøvde å logge inn på Ducky med %{provider}, men vi får ingen e-postadresse tilbake. Innloggingen fungerte derfor ikke.\r\n\r\nDu kan enten verifisere e-posten din hos %{provider} og prøve på nytt, eller opprette konto på en annen måte!',
  register_account: 'Registrer konto',
  register_with_facebook: 'Registrer med Facebook',
  register_with_google: 'Registrer med Google',
  repeat_password: 'Bekreft passord',
  terms_and_conditions_text: 'Ved å registrere konto godtar du ',
  terms_and_conditions_link: 'betingelser for bruk og personvern',
  terms_and_conditions_ducky: ' på ducky.eco.',
  valid_email: 'Skriv inn gyldig e-postadresse',
  valid_email_misspelled: 'Har du skrevet e-posten riktig?',
  valid_name: 'Skriv inn et gyldig navn',
  valid_password: 'Skriv inn riktig passord',
  use_email: 'Registrer med e-post',
  use_another: 'Bruk en annen registreringsmetode',
  verify_email_address: 'Bekreft e-postadressen din',
  thanks_for_joining:
    'Takk for at du ble med! For å fullføre registreringen, sjekk og bekreft e-posten vi sendte til',
  wrong_address: 'feil e-postadresse?',
  login_again: 'og prøv igjen',
  not_received: 'Har du ikke mottatt en e-post?',
  resend: 'Prøv igjen',
  refresh: 'Last siden på nytt',
  resend_email: 'SEND NY EPOST',
  check_email_address: 'Sjekk e-posten din',
  follow_instructions_create:
    'Følg instruksjonene for å opprette et passord i e-postmeldingen som sendes til',
  follow_instructions_reset:
    'Følg instruksjonene for å bytte passord i e-postmeldingen som sendes til',
  create_a_password: 'Lag et passord',
  must_be_8_characters: 'Må bestå av minst 8 tegn',
  create_password: 'LAG PASSORD',
  password_created: 'Passord opprettet!',
  use_next_time: 'Bruk dette passordet neste gang du logger deg på',
  continue: 'FORTSETT',
  dont_have_password:
    'Har du registrert deg med e-post men uten passord? Ikke få panikk!',
  follow_steps: 'Følg trinnene for å lage et passord.',
  email_confirmed: 'E-post verifisert!',
};
